import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { EtlService } from '../../vault-data-migration-etl/etl.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AvailableServiceTsService } from '../../available-service/available-service.ts.service';
import { Action } from 'rxjs/internal/scheduler/Action';
/**
 * Added By Abhishek t
 * 16-10-2023
 * This component represents the dialog for running JAR services. It handles the form, validation, and data updates.
 */
export interface CheckinListDialogData {
  edata: any;
  // Add other properties you receive in the data object
}

@Component({
    selector: 'app-running-jar-popup',
    templateUrl: './running-jar-popup.component.html',
    styleUrls: ['./running-jar-popup.component.scss'],
    standalone: false
})
 
export class RunningJarPopupComponent implements OnInit {
  //console.log(this.constructor.name);
  tooltipMessage: String = '';
  migrationType: string='';
  FormValid: FormGroup;
  runningService: any = {
    'extraction': 0,
    'transform': 0,
    'loader': 0,
    'loadtoftp': 0,
    'runid':0,
    'validation':0,
    'status':"",
    'availableserviceID':0,
    'migrationType' :""
  };
  buttonName: any;
gridname;
  constructor(
    public dialogRef: MatDialogRef<RunningJarPopupComponent>,private etlService:EtlService, private spinner: NgxUiLoaderService, private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: CheckinListDialogData,private localStorageSettings: LocalStorageSettingsService,private availService:AvailableServiceTsService
  ) {}
  backgroundColorButton;
  ngOnInit() {
    console.log(this.constructor.name);
    this.tooltipMessage='This screen is for allocating the maximum number of ETL services for each run/migration. Allocate resources prudently based on data volume to ensure balanced utilization, avoiding scenarios where some runs overuse resources while others remain underutilized';
  


    this.formValidations();
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    this.buttonName = this.data.edata.buttonName;
    // this.buttonName='save';

    const { extraction, transform, loader, loadtoftp } = this.data.edata;
    console.log(this.data.edata);

   
      this.runningService = {
        'extraction': extraction || 0,
        'transform': transform || 0,
        'loader': loader || 0,
        'loadtoftp': loadtoftp|| 0,
        'runid':this.data.edata.runid||0,
        'validation':this.data.edata.validation||0,
        'status':this.data.edata.status,
        'availableserviceID':this.data.edata.availableserviceID||0,
        'migrationType':this.data.edata.migrationType,
        'parentmigrationid':this.data.edata.parentRunid
      };
      console.log(this.runningService);
      this.migrationType=this.runningService.migrationType;
     console.log(this.migrationType)
   if(this.data.edata.gridname!=null&&this.data.edata.gridname!=undefined){
    this.gridname=this.data.edata.gridname;
   }
   console.log(this.localStorageSettings.getSettings('ColorA'));
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    //modified by kameshwar
    //date 07-11-2025
    //remove disable code for validation
    if(this.runningService.parentmigrationid>0){
      console.log(this.runningService.parentmigrationid)
      this.FormValid.get('loader').disable()
      this.FormValid.get('loadtoftp').disable()
      this.FormValid.get('validation').disable()
      this.FormValid.get('transform').disable()
      this.FormValid.get('extraction').disable()

    }
    if(this.migrationType ==='Data Virtualization'){
      this.FormValid.get('loader').disable()
      this.FormValid.get('loadtoftp').disable()

    }
    
     

  }

  formValidations() {
    this.FormValid = new FormGroup({
      'extraction': new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      'transform': new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      'loader': new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      'loadtoftp': new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      'validation': new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
    });
  }
  updateData() {
    console.log(this.runningService);
    console.log(this.gridname);
  
    // Check if the form is valid
    if (this.FormValid.valid) {
      this.spinner.start();
      const dnsId = this.localStorageSettings.getSettings('dnsName');
      console.log(this.runningService);
  
      if (this.gridname == 'availableService') {
        this.availService.saveAvailServices(this.buttonName, this.runningService).subscribe(response => {
          if (response.error == true) {
            console.log('inside error');
            console.log(response);
            this.spinner.stop();
            this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });
          } else {
            this.spinner.stop();
            this.dialogRef.close();
            this.snackBar.open(response.statusMessage, 'OK', { duration: 50000 });
          }
        });
      } else {
        this.spinner.start();
        this.etlService.saveRunningServices(parseInt(dnsId), this.runningService).subscribe(response => {
          if (response.error == true) {
            console.log('inside error');
            console.log(response);
            this.spinner.stop();
            this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });
          } else {
            this.spinner.stop();
            this.dialogRef.close();
            this.snackBar.open(response.statusMessage, 'OK', { duration: 50000 });
          }
        });
      }
    } else {
      if (this.runningService.parentmigrationid > 0) {
        console.log(this.runningService.parentmigrationid);
        this.snackBar.open('This is an incremental migration. Incremental migrations (child) inherit properties from full data migrations (parent). Please configure the changes in the parent migration run.', 'OK', { duration: 5000 });
      } else {
        // The form is not valid, you can handle it here (e.g., show an error message).
        console.log('Please fill in all required fields.');
        this.snackBar.open("All mandatory fields to be filled", 'OK', { duration: 50000 });
      }
    }
  }
  
  

  close() {
    this.dialogRef.close();
  }
}
